export enum EventOrganiserTypeEnum {
    SurgicalMedicalLeadOrganiser = "118950000",
    NonSurgicalMedicalLeadOrganiser = "118950001"
}